// Configuration for the store
export const STORE_ID = 7;

// Default locale
export const DEFAULT_LOCALE = 'ar';
export const FALLBACK_LOCALE = 'fr';

export const API_BASE_URL = 'https://gestionshoop.shooplinkdz.com/backend/api.php';
